var OfferComponent = /*@__PURE__*/ (function () {
    function OfferComponent(data) {
        if (data.internalLabel) {
            this.internalLabel = data.internalLabel;
        }
        if (data.refId) {
            this.refId = parseInt(data.refId, 10);
        }
        if (data.type) {
            this.type = data.type;
        }
        this.prices = [];
    }
    OfferComponent.prototype.addPrice = function (price) {
        this.prices.push(price);
    };
    return OfferComponent;
}());
export { OfferComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/offer/offer.component.ts
// module id = null
// module chunks = 